/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './DenFraudesGolpe.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function DenFraudesGolpe() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="den-fraudes-golpe">
        <ContainerHome24>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <picture>
                  <source type="image/png" srcSet="assets/denuncias-e-fraudes/img-golpe.png" />
                  <img
                    src="assets/denuncias-e-fraudes/img-golpe.png"
                    alt="Casal pesquisando sobre como detectar um golpe no site da Santander Financiamentos."
                    className="img-golpe"
                  />
                </picture>
              )}
              {width > 992 && (
                <picture>
                  <source type="image/png" srcSet="assets/denuncias-e-fraudes/img-golpe-desk.png" />
                  <img
                    src="assets/denuncias-e-fraudes/img-golpe-desk.png"
                    alt="Casal pesquisando sobre como detectar um golpe no site da Santander Financiamentos."
                    className="img-golpe"
                  />
                </picture>
              )}
            </>
          )}
          <div className="golpe-conteudo">
            <h3 className="golpe-titulo">Como detectar um golpe?</h3>
            <p className="golpe-texto">
              Antes de efetuar um pagamento, revise as informações do boleto e o beneficiário (quem
              vai receber o seu pagamento). Só efetue o pagamento se as informações estiverem
              corretas. Para seu conhecimento,{' '}
              <a href="blog/como-identificar-fraudes-em-boletos.html" target="_blank">
                saiba como identificar se o seu boleto é verdadeiro
              </a>
              .
              <br />
              <br />
              Em caso de dúvida sobre a <b>autenticidade do boleto</b> ou suspeita de um{' '}
              <b>golpe</b>,{' '}
              <a href="blog/prevencao-de-golpes.html" target="_blank">
                confira nossas dicas
              </a>{' '}
              ou entre em contato com a gente pelo telefone 4004-9090 (capitais e regiões
              metropolitanas) ou 0800 722 9090 (demais localidades).
            </p>
            <img
              src="assets/denuncias-e-fraudes/ic_urgent.svg"
              className="img-denuncia desktop"
              alt="imagem denuncia"
            />
            <img
              src="assets/denuncias-e-fraudes/ic_urgent-DESK.svg"
              className="img-denuncia mobile"
              alt="imagem denuncia"
            />
          </div>
        </ContainerHome24>
        {/* <img
          src="assets/denuncias-e-fraudes/img-bg-denuncias-e-fraudes.svg"
          className="img-boleto"
          alt=""
        /> */}
        {/*<img src="assets/boleto25/img-dda-desk.png" className="img-dda-desk" alt="" /> */}
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default DenFraudesGolpe;
